import { LinkableEntityType } from '@api';
import { LegacyAnchor } from '@common';

type TourAnchorPropsType = {
  tour: LinkableEntityType;
  children?: React.ReactNode;
};

export const TourAnchor: React.FC<TourAnchorPropsType> = ({
  tour,
  children,
}) => {
  return (
    <LegacyAnchor href={`/projects/touring/${tour.id}`}>
      {children ?? tour.name}
    </LegacyAnchor>
  );

  // TODO: Replace LegacyAnchor with Anchor when we have the new touring page

  // return (
  //   <Anchor key={tour.id} to={`/projects/touring/$id`} params={{ id: tour.id }}>
  //     {children ?? tour.name}
  //   </Anchor>
  // );
};
